import { Field, Int } from '@nestjs/graphql'
import { IdDto } from '../../base'
import { ObjectType } from '@nestjs/graphql'

@ObjectType()
export class UserAnalysisTeamDto extends IdDto{
  @Field()
  name!: string

  @Field()
  image!: string

  @Field(t => Int)
  memberType!: number

  @Field(t => Int)
  memberStatus!: number

  @Field(t => Int)
  memberId!: number

  @Field(t => Int)
  memberUserId!: number

  @Field({ nullable: true })
  memberStatusReason!: string

  @Field(t => Int, { nullable: true })
  memberStatusReasonType!: number
}
